import React from 'react';

function ContactUsPartial() {
    return (
        <section className="relative">
            <div className="relative mx-auto w-full max-w-6xl px-4 sm:px-6">
                <div className="py-12 md:py-16">
                    <div className="relative overflow-hidden rounded-3xl bg-gray-900 bg-opacity-90 px-6 py-10 md:px-10 shadow-2xl border border-gray-800">
                        {/* Accent strip on top */}
                        <div className="pointer-events-none absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 via-purple-400 to-pink-500" />

                        <div className="relative mx-auto max-w-3xl text-center">
                            {/* Section header */}
                            <p
                                className="mb-3 text-xs font-semibold tracking-[0.2em] text-blue-300 uppercase"
                                data-aos="fade-up"
                            >
                                READY TO EXPLORE?
                            </p>

                            <h1
                                className="h2 mb-4 text-gray-100"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                Contact us for a demo.
                            </h1>

                            <p
                                className="mb-6 text-base sm:text-lg text-gray-200"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                See how our devices work in real programmes. We can walk you
                                through the platform and arrange trial devices where appropriate.
                            </p>

                            {/* CTA */}
                            <div
                                className="mt-4 flex flex-col items-center gap-3 sm:flex-row sm:justify-center"
                                data-aos="fade-up"
                                data-aos-delay="300"
                            >
                                <a
                                    href="mailto:info@agmtechnologies.co.uk?subject=Book%20a%20demo&body=Hi%20AGM%20Technologies%2C%0D%0A%0D%0AWe%27d%20like%20to%20arrange%20a%20demo%20and%20discuss%20trial%20devices.%0D%0A%0D%0ARegards%2C"
                                    className="group relative inline-flex items-center justify-center"
                                >
                                    {/* Glowing background */}
                                    <span className="absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-70 filter blur-sm group-hover:opacity-100 transition-opacity duration-300" />

                                    {/* Button body */}
                                    <span className="relative inline-flex items-center justify-center rounded-xl border border-gray-100 bg-black bg-opacity-70 px-8 py-3 text-base font-semibold text-gray-100 tracking-wide">
                     Talk to us about trials!
                                    </span>
                                </a>

                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ContactUsPartial;
